import { visserApi } from './visserApi';
const getAll = async () => {
    return await visserApi.get('workType/GetAll');
};
const getById = async (id) => {
    return await visserApi.get(`workType/GetById/${id}`);
};
const update = async (updateWorkType) => {
    return await visserApi.put('workType/Update', updateWorkType);
};
const WorkTypeApi = {
    getAll,
    getById,
    update
};
export default WorkTypeApi;
